import React from "react"
import { useIntl } from "react-intl"

import FormTextField, { FormTextFieldProps } from "./FormTextField"
import inputMessages from "../../messages/input"
import withValidateController from "./withValidateController"

export default function FormEmailField({
    name = "email",
    large = true,
    inputProps,
    onBlur,
    onChange,
    ...rest
}: FormTextFieldProps) {
    const intl = useIntl()
    const { style: inputPropsStyle = {}, ...restInputProps } = inputProps || {}

    return (
        <FormTextField
            {...rest}
            large={large}
            name={name}
            type="email"
            label={intl.formatMessage(inputMessages.email)}
            onBlur={(e) => {
                e.target.value = e.target.value.trim()
                onBlur?.(e)
            }}
            onChange={(e) => {
                e.target.value = e.target.value.toLowerCase()
                onChange?.(e)
            }}
            inputProps={{
                style: {
                    ...inputPropsStyle,
                    textTransform: "lowercase",
                },
                ...restInputProps,
            }}
        />
    )
}

export const ValidatableFormEmailField = withValidateController(FormEmailField)
